<!--
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-05-19 13:54:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/delivery/edit.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="edit" v-if="permissions.delivery_edit">编辑投放记录</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <delivery-form operate-type="edit"></delivery-form>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryForm from "./component/form";
import { mapGetters } from "vuex";

export default {
    computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  data() {
    return {
      activeIndex: "edit",
      queryData: {}
    };
  },
  components: {
    DeliveryForm
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
  }
}
</script>